import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NavigationComponent } from '../navigation/navigation.component';
import { ShellUser } from '../../models/shell-user.interface';

@Component({
  selector: 'tc-navbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NavigationComponent, RouterLink],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class NavbarComponent {
  @Input() user: ShellUser | null = null;
  @Input() logoUrl = '/images/logo.svg';
  /** Optional product name shown next to the logo (e.g. "Billing"). */
  @Input() brandLabel = '';
  @Input() profileLabel = 'Profil';
  @Input() logoutLabel = 'Odhlásit';

  @Output() toggleSidebar = new EventEmitter<void>();
  @Output() closeSidebar = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  onToggleClick(): void {
    this.toggleSidebar.emit();
  }

  onMenuItemClicked(): void {
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      this.closeSidebar.emit();
    }
  }

  onLogoutClick(): void {
    this.logout.emit();
  }

  getAvatarUrl(): string {
    if (this.user?.avatarUrl) {
      return this.user.avatarUrl;
    }
    const name = this.user?.displayName ?? 'User';
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=336aa6&color=fff`;
  }
}
